import { createSlice } from "@reduxjs/toolkit";
import getReportId from "@custom/rtk-apis/report/GetReportId";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const getRadiologistUserSlice = createSlice({
  name: "getRadiologistUserSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(getReportId.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getReportId.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getReportId.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getRadiologistUserSlice.reducer;
